const initialState = {
    comments: [],
    loading: false,
    detailLoading: false,
    formLoading: false,
    error: null,
};

export default function commentReducer(state = initialState, action) {
    switch (action.type) {
        case 'COMMENT_POST_REQUEST':
            return { ...state, formLoading: true, error: null };
        case 'COMMENT_POST_SUCCESS':
            return { ...state, formLoading: false, result: action.payload };
        case 'COMMENT_POST_FAILURE':
            return { ...state, formLoading: false, error: action.error };

        case 'COMMENT_PUT_REQUEST':
            return { ...state, formLoading: true, error: null };
        case 'COMMENT_PUT_SUCCESS':
            return { ...state, formLoading: false, result: action.payload };
        case 'COMMENT_PUT_FAILURE':
            return { ...state, formLoading: false, error: action.error };

        case 'GET_COMMENTS_LOADING':
            return { ...state, loading: true, error: null };
        case 'GET_COMMENTS_SUCCESS':
            return { ...state, loading: false, comments: action.payload };
        case 'GET_COMMENTS_FAILURE':
            return { ...state, loading: false, error: action.error };

        case 'COMMENT_GETBYID_REQUEST':
            return { ...state, detailLoading: true, error: null };
        case 'COMMENT_GETBYID_SUCCESS':
            return { ...state, detailLoading: false, result: action.payload };
        case 'COMMENT_GETBYID_FAILURE':
            return { ...state, detailLoading: false, error: action.error };

        default:
            return state;
    }
}
